import { FormBuilder, FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';

import { Filter, FilterTypes } from './filters';

/**
 * Builds a form based on filters.
 *
 * @param filters - An array of filters.
 * @param form - The form group to build upon. If not provided, a new form group will be created.
 * @returns The built form group.
 */
@Injectable()
export class FiltersFormBuilderService {
  constructor(private fb: FormBuilder) {}

  public buildForm(filters: Filter[], form: FormGroup<Record<string, any>> = null): FormGroup<Record<string, any>> {
    // If form is not provided, create a new form group.
    form = form ?? this.fb.group({});

    // Iterate over each filter and add a control to the form.
    for (const filter of filters) {
      const key = `${filter.key}`;
      if (filter.associations?.length > 0) {
        this.buildForm(filter.associations, form);
      } else {
        if (filter.type === FilterTypes.Range) {
          const nextValues = filter.values ?? { from: null, to: null };
          form.addControl(key, this.fb.group(nextValues, { updateOn: 'blur' }));
        } else {
          form.addControl(key, this.fb.control(filter.values ?? null, { updateOn: 'blur' }));
        }
      }
    }

    return form;
  }
}
